exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled[data-v-a468f6a2] {\n  background-color: gray;\n}\n", ""]);

// exports
